import React from "react";

function AdminEspeciales({
  especiales,
  handleEditarMarketing,
  handleEliminarMarketing,
}) {
  return (
    <div>
      <div
        style={{
          fontSize: "12px",
          fontWeight: "900",
          color: "#111",
          marginBottom: "6px",
        }}
      >
        🌟 Especiales ({especiales.length})
      </div>

      {especiales.length === 0 ? (
        <div
          style={{
            fontSize: "12px",
            color: "#999",
            fontStyle: "italic",
          }}
        >
          No hay especiales publicados.
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {especiales.map((e) => (
            <div
              key={e.id}
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                padding: "10px",
                border: "1px solid #eee",
                borderRadius: "12px",
                backgroundColor: "#fff",
              }}
            >
              {e.tipo === "video" ? (
                <video
                  src={e.url}
                  preload="metadata"
                  muted
                  playsInline
                  style={{
                    width: "58px",
                    height: "40px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              ) : (
                <img
                  src={e.url}
                  alt=""
                  loading="lazy"
                  decoding="async"
                  style={{
                    width: "58px",
                    height: "40px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              )}

              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "900",
                  }}
                >
                  {e.titulo || "(Sin título)"}
                </div>

                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                  }}
                >
                  {e.descripcion || ""}
                </div>
              </div>

              <button
                type="button"
                onClick={() => handleEditarMarketing(e, "especiales")}
                style={{
                  border: "1px solid #111",
                  backgroundColor: "#fff",
                  padding: "6px 10px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontWeight: "800",
                  fontSize: "12px",
                }}
              >
                Editar
              </button>

              <button
                type="button"
                onClick={() => handleEliminarMarketing(e.id, "especiales")}
                style={{
                  border: "1px solid #fce8e6",
                  backgroundColor: "#fff",
                  color: "#c5221f",
                  padding: "6px 10px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  fontWeight: "900",
                  fontSize: "12px",
                }}
              >
                Borrar
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminEspeciales;
